const Footer = () => {
  return (
    <footer>
      &copy; 2023 Luana Palhares
      <a
        href="https://github.com/lubeires/knowyourtaste"
        rel="noreferrer"
        target="_blank"
      >
        <i className="fa-brands fa-github fa-lg"></i>
        lubeires
      </a>
    </footer>
  );
};

export default Footer;
